import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {
  constructor(public router: Router, private readonly toastService: ToastrService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(({ error }: HttpErrorResponse) => {
        if (error.status.code === 400 && error.messages === 400) {
          this.message(error.data || 'Error');
        } else {
          this.message(error.messages || error.message || 'Error');
        }
        this.unAuthorized(error.data.message, error.status.code);
        return throwError(() => new Error(error));
      }),
    );
  }

  unAuthorized(message: string, status: number): void {
    if (['Unauthorized'].includes(message) && [500].includes(status)) {
      this.router.navigate(['/auth/sign-in']);
    }
  }

  message(alert: string | { message: string } | { error: string; field: string }[]): void {
    if (Array.isArray(alert)) {
      alert = alert.map((a) => a.error).join(', ');
    } else if (typeof alert === 'object') {
      alert = (alert as { message: string }).message;
    }
    this.toastService.error(alert);
  }
}
